<template>
  <div>
    <h3 class="spl-export-proof-style">
      Name *
    </h3>
    <form-input
      v-model="name"
      required="true"
      data-cy="export-proof-edit-name" />
    <h3 class="spl-export-proof-style">
      Description
    </h3>
    <form-textarea
      v-model="description"
      :required="false"
      data-cy="export-proof-edit-description" />
  </div>
</template>

<script lang="ts">
import { mapState, mapMutations } from 'vuex'
import { set, cloneDeep } from 'lodash'
export default {
  data () {
    return {
      name: '',
      description: ''
    }
  },
  computed: {
    ...mapState('exportProof', ['currentEditExportProof'])
  },
  watch: {
    name () {
      this.setCurrentEditExportProof(set(cloneDeep(this.currentEditExportProof), 'Export_Proof_Name', this.name))
    },
    description () {
      this.setCurrentEditExportProof(set(cloneDeep(this.currentEditExportProof), 'Export_Proof_Description', this.description))
    }
  },
  mounted () {
    this.name = this.currentEditExportProof.Export_Proof_Name
    this.description = this.currentEditExportProof.Export_Proof_Description
  },
  methods: {
    ...mapMutations('exportProof', ['setCurrentEditExportProof'])
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';
  .spl-export-proof-style {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
  }
</style>
